






































































import SharedContentSideCard from "@/components/partner/SharedContentSideCard.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { Component, Prop, Vue } from "vue-property-decorator";
import ReportClearanceApprovalRequestDialog from "./ReportClearanceApprovalRequestDialog.vue";
import ReportClearanceApprovalUpdateStatusDialog from "./ReportClearanceApprovalUpdateStatusDialog.vue";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";

@Component({
  components: {
    ReportClearanceApprovalRequestDialog,
    ReportClearanceApprovalUpdateStatusDialog,
    SharedContentSideCard
  }
})
export default class ClearanceApprovalSheet extends Vue {
  readonly RequestStatusEnum = RequestStatusEnum;
  @Prop({ required: true }) clearanceApproval!: IClearanceApproval;
  @Prop({ required: true }) report!: IReport;
  isDialogOpen = false;
  isCreateDialogOpen = false;
  sharedContentSideCardItem?: ISharedContent | null = null;

  ResourceEnum = ResourceEnum;

  @Prop()
  color?: string;

  get filters() {
    const filter: IPageFilterElement[] = [];
    if (!this.report) return filter;

    filter.push(new PageFilterElement({ value: this.report.id, key: "refs.refId", operation: "$eq" }));

    return filter;
  }

  goToDetail() {
    this.clearanceApproval.goTo(this.$router).detail();
  }
}
